import { defineMessages } from "react-intl";

export default defineMessages({
  noAgreement: {
    id: "orderDescription.noAgreement",
    defaultMessage: "No agreement ?",
  },
  opposePayment: {
    id: "orderDescription.opposePayment",
    defaultMessage: "Oppose to the payment",
  },
  confirm: {
    id: "confirm",
    defaultMessage: "Confirm",
  },
  cancel: {
    id: "cancel",
    defaultMessage: "Cancel",
  },
  "taskCreationBlockedModal.title": {
    id: "taskCreationBlockedModal.title",
    defaultMessage: "You can't create a request right now",
  },
  "taskCreationBlockedModal.body": {
    id: "taskCreationBlockedModal.body",
    defaultMessage:
      "Your account has a restriction due to recent activity on the platform. If you think this is a mistake or need more details, please contact our support team.",
  },
  "taskCreationBlockedModal.contactSupportButton": {
    id: "taskCreationBlockedModal.contactSupportButton",
    defaultMessage: "Contact support",
  },
  "taskCreationBlockedModal.contactSupportUrl": {
    id: "taskCreationBlockedModal.contactSupportUrl",
    defaultMessage: "https://ringtwice.be/fr/contact?contact-form=true",
  },
  // Reuses the id EditServiceRequestModal already ships, so the string is not
  // sent for translation a second time.
  returnButton: {
    id: "editServiceRequestModal.returnButton",
    defaultMessage: "Return",
  },
});
